import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PLAN_LABEL = {
  plan_associado: "Associado Ativo",
};

export const ACTIVATION_PRICE_LABEL = "R$ 39,90";
export const LAUNCH_DATE_ISO = "2027-01-02T00:00:00-03:00";
export const LAUNCH_DATE_LABEL = "2 de janeiro de 2027";
